<template>
  <Container>
    <template #header>
      <div class="block-info_header">
        <Text
          pattern="body2"
          :weight="500"
          :height="150"
          align="left"
          color="#787878"
        >
          {{ $t("Hash") }}
        </Text>
        <div class="block-info_header_hash">
          <Text pattern="body2" :weight="500" :height="150" align="left">
            {{ hash }}
          </Text>
          <button
            class="block-info_header_button"
            @click="copyToClipboard(hash)"
          >
            <BaseSvgIcon class="copy" name="copy" />
            <span>{{ $t("Copy") }}</span>
          </button>
        </div>
      </div>
    </template>
    <template #body>
      <div class="block-info_body">
        <div class="block-info_body_main">
          <div
            class="block-info_body_item"
            v-for="{
              id,
              label,
              value,
              underline,
              icon,
              copy,
              comma: withComma,
            } in data"
            :key="id"
          >
            <Text pattern="body2" :weight="500" :height="150" color="#787878">
              {{ $t(label) }}
            </Text>
            <div class="block-info_body_item_value">
              <BaseSvgIcon
                v-if="icon"
                :name="icon"
                class="block-info_body_item_value_icon"
              />
              <div class="block-info_body_item_value_titles">
                <Text
                  v-if="value.title"
                  pattern="body2"
                  :weight="500"
                  :height="135"
                  :textDecoration="underline ? 'underline' : 'none'"
                >
                  {{ $t(withComma ? comma(value.title) : value.title) }}
                  <span v-if="value.posttitle" class="posttitle">
                    {{ value.posttitle }}
                  </span>
                </Text>
                <Text
                  v-if="value.subtitle"
                  pattern="body2"
                  color="#7E7E7E"
                  :weight="500"
                  :height="135"
                >
                  {{ value.subtitle }}
                </Text>
              </div>
              <BaseSvgIcon
                v-if="copy"
                name="copy"
                class="copy"
                @click="copyToClipboard(value.title)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script>
import { Container } from "@/shared/ui";
import { Text, BaseSvgIcon } from "@/shared/ui";
import { comma } from "@/shared/utils/format";
import "@/assets/icons/SVG/copy.svg";
import "@/assets/icons/SVG/check2.svg";

export default {
  name: "BlockInfo",
  components: { Text, BaseSvgIcon, Container },
  props: {
    hash: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    comma,
    copyToClipboard(value) {
      navigator.clipboard.writeText(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.block-info {
  &_header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    gap: 1px;

    &_hash {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 1px;
    }

    &_button {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      color: #c18afd;
      transition: color 0.3s;
      .copy {
        min-width: 20px;
        min-height: 20px;
        transition: color 0.3s;
        cursor: pointer;
        color: #c18afd;
      }

      &:hover {
        color: #fff;

        .copy {
          color: #fff;
        }
      }
    }
  }

  &_body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;

    &_main {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-top: 16px;
      width: 100%;
      grid-column-gap: 10px;
    }

    &_button {
      width: 100%;
    }

    &_item {
      display: grid;
      grid-template-columns: 1fr 1.5fr;
      border-bottom: 1px solid #1a1a1a;
      padding: 16px 0px;

      &_value {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 6px;

        &_titles {
          display: flex;
          flex-direction: column;
          gap: 2px;

          .posttitle {
            color: #8b8b8b;
          }
        }

        .copy {
          min-width: 16px;
          min-height: 16px;
          transition: color 0.3s;
          cursor: pointer;
          color: #c18afd;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
